import { boolean, nullable, number, object, record, string } from "../../../types/_types";

export const Vendor = object({
	billingInstructions: nullable(string()),
	city: string(),
	country: string(),
	description: nullable(string()),
	email: nullable(string()),
	name: string(),
	organizationNumber: string(),
	phone: nullable(string()),
	primary: boolean(),
	secondaryStreet: nullable(string()),
	sortOrder: number().default(0),
	state: nullable(string()),
	street: string(),
	vat: nullable(string()),
	zip: nullable(string()),
});

export const Vendors = record(string().min(8), Vendor);
